// extracted by mini-css-extract-plugin
export default {"authorList":"Abstracts_authorList__olXL-"};